import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {UserProfile} from '@shared/interfaces';
import {AuthState} from '@shared/state/auth/auth.state';
import {Select, Store} from '@ngxs/store';
import {Logout} from '@shared/state/auth/auth.actions';
import {takeUntil} from 'rxjs/operators';
import {MENU_ITEMS} from './const';
import {isOwner, isReadOnly} from '@shared/helpers';
import {ViewerService} from '@app/service/util/viewer.service';
import {SimulateCarComponent} from '@shared/components/simulate-car/simulate-car.component';
import {CreateDatasetComponent} from '@shared/components/create-dataset/create-dataset.component';
import {StorageService} from '@app/service/util/storage.service';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss']
})

export class FullLayoutComponent implements OnInit, OnDestroy {
  @Select(AuthState.getUserData) user$: Observable<UserProfile>;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  isExpand: boolean; // Toggle the nav bar itself

  menu: any[] = [];
  isCollapsed = false;
  initials: any;
  user: any;

  isCheckedOnce = false;

  COLLAPSED_KEY = 'isCollapsed';

  constructor(private cd: ChangeDetectorRef, private store: Store, private viewerService: ViewerService,
              private storage: StorageService) {
  }

  ngOnInit() {
    this.storage.observeValue(this.COLLAPSED_KEY)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        this.isCollapsed = value;
      });
    this.user$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(userData => {
        this.user = userData;
        this.initials = userData?.name?.split(' ').map((n) => n[0]).join('');
      });

    this.store.select(AuthState.getUserData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userData) => {
        if (userData) {
          this.menu = MENU_ITEMS; // Reset the menu items to flush added navigation
          const currentMenu = this.menu.map(val => val.title);
          // If the user's role is owner, add carvry AI
          // if (isOwner(userData.role) && !currentMenu.includes('App Manager')) {
          //   this.menu.splice(this.menu.length, 0, {
          //     title: 'App Manager',
          //     icon: 'appstore',
          //     link: '/app-manager'
          //   });
          // }
          if (isOwner(userData.role) && !currentMenu.includes('AI Data Center')) {
            this.menu.splice(this.menu.length, 0, {
              title: 'AI Data Center',
              icon: 'database',
              link: '/ai-data-center'
            });
          }
          if (isOwner(userData.role) && !currentMenu.includes('AI Training')) {
            this.menu.splice(this.menu.length, 0, {
              title: 'AI Training',
              icon: 'build',
              link: '/ai-training'
            });
          }
          if (isOwner(userData.role) && !currentMenu.includes('Simulation Hub')) {
            this.menu.splice(this.menu.length, 0, {
              title: 'Simulation Hub',
              icon: 'build',
              link: '/simulation-hub'
            });
          }
          if (!isReadOnly(userData.role) && !currentMenu.includes('Settings')) {
            const settingsMenu = {
              title: 'Settings',
              icon: 'setting',
              link: '/settings'
            };
            this.menu.splice(this.menu.length, 0, settingsMenu);
          }
        }
      });
  }

  updateCollapsed() {
    this.isCollapsed = !this.isCollapsed;
    this.storage.saveValue(this.COLLAPSED_KEY, this.isCollapsed);
  }

  createSimulation() {
    const metadata = {
      nzTitle: 'Simulate Car Prices',
      nzFooter: null,
      nzClassName: 'simulate-price-modal'
    };
    this.viewerService.createModal(SimulateCarComponent, null, metadata);
  }

  createDataset() {
    const metadata = {
      nzTitle: 'Create Dataset',
      nzFooter: null,
      nzClassName: 'create-dataset-modal'
    };
    this.viewerService.createModal(CreateDatasetComponent, null, metadata);
  }

  logout() {
    this.store.dispatch(new Logout());
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
